import { useCallback } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import { useFeatures } from "../../hooks/useFeatures";
import useDmeOrderToasts from "../../hooks/useDmeOrderToasts";
import { isAssignableProvider } from "../../utils/dmeNotificationPrefs";

// App-level bridge for provider-facing DME notifications. Keeping this above
// the route switch means an in-app-only notification is still visible when the
// user is working somewhere other than /orders. Clicking a toast navigates to
// the order route, where Orders consumes the query parameters and opens the
// requested drawer tab.
export default function DmeOrderNotificationBridge() {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const { hasFeature } = useFeatures();
  const isProviderOrg = !!auth?.user && hasFeature("orders") && !hasFeature("ordersManagement");

  const isDoctor = isAssignableProvider(auth?.user);

  const openOrder = useCallback(
    (orderId, initialTab = null) => {
      if (orderId == null || String(orderId).length === 0) return;
      const params = new URLSearchParams({ orderId: String(orderId) });
      if (initialTab) params.set("tab", initialTab);
      navigate(`/orders?${params.toString()}`);
    },
    [navigate]
  );

  useDmeOrderToasts({
    isProviderOrg,
    currentUserId: auth?.user?.id,
    onOpenOrder: openOrder,
    userCustom: auth?.user?.custom,
    isDoctor,
  });

  return null;
}
